import { useEffect } from "react";
import { startContrastGuard, stopContrastGuard } from "@/lib/contrastGuard";

// Backend-Theme (Schwarz/Weiß): shadcn-Tokens global umschalten,
// inkl. Portal-Komponenten (Dialog, Select, Popover, Toast).
export function useBackendTheme() {
  useEffect(() => {
    document.documentElement.classList.add("bw");
    applyStoredMode();
    startContrastGuard();
    return () => {
      stopContrastGuard();
      document.documentElement.classList.remove("bw", "bw-dark");
    };
  }, []);
}

// Alt-Name für Bestandsimporte
export const useBackendDarkTheme = useBackendTheme;

// ---------------------------------------------------------------- Dark-Mode
const KEY = "yg_backend_mode";

export const getStoredMode = () => (localStorage.getItem(KEY) === "dark" ? "dark" : "light");

export function applyMode(mode) {
  const dark = mode === "dark";
  document.documentElement.classList.toggle("bw-dark", dark);
  localStorage.setItem(KEY, dark ? "dark" : "light");
  window.dispatchEvent(new CustomEvent("yg-backend-mode", { detail: dark ? "dark" : "light" }));
}

const applyStoredMode = () => applyMode(getStoredMode());
